import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../base/Button';

export default function Header_v2() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMoreOpen, setIsMoreOpen] = useState(false);

  return (
      <header className="w-full">
        {/* Top black bar */}
        <div className="bg-black text-white text-xs">
          <div className="mx-auto w-full max-w-[1514px] text-[14px] px-8 py-3 flex flex-col md:flex-row justify-between gap-2">
            <span>Opening February - 2026 - Grand Opening Memberships</span>
            <span>
            Central Langley / Willowbrook. 105-19925 Willowbrook Dr., Langley
          </span>
          </div>
        </div>

        {/* Main header */}
        <div className="bg-white">
          <div className="mx-auto w-full max-w-[1514px] px-6 h-20 flex items-center justify-between">

            {/* Logo */}
            <Link to="/" className="flex items-center">
              <img
                  src="/img/logo_header_v2.png"
                  alt="YOGA7"
                  className="h-16 w-auto object-contain"
              />
            </Link>

            {/* Desktop navigation */}
            <div className="hidden lg:flex items-center gap-32">
              <nav className="flex items-center gap-8 font-medium text-gray-900">
                <Link to="/membership" className="hover:text-[#62b6a6] text-[20px] transition">
                  Memberships
                </Link>
                <Link to="/classes" className="hover:text-[#62b6a6] text-[20px] transition">
                  Classes
                </Link>
                <Link to="/infrared-hot-yoga" className="hover:text-[#62b6a6] text-[20px] transition">
                  Infrared Hot Yoga
                </Link>
                <Link to="/schedule" className="hover:text-[#62b6a6] text-[20px] transition">
                  Schedule
                </Link>

                {/* More dropdown */}
                <div
                    className="relative"
                    onMouseEnter={() => setIsMoreOpen(true)}
                    onMouseLeave={() => setIsMoreOpen(false)}
                >
                  <button className="flex items-center gap-1 text-[20px] hover:text-[#62b6a6] transition">
                    More
                    <i className="ri-arrow-down-s-line text-sm"></i>
                  </button>

                  {isMoreOpen && (
                      <div className="absolute top-full left-0 mt-2 w-40 bg-white rounded-lg shadow-xl py-2 z-50">
                        <Link
                            to="/about"
                            className="block px-4 py-2 hover:bg-gray-50 text-[20px] hover:text-[#62b6a6]"
                        >
                          About
                        </Link>
                        <Link
                            to="/events"
                            className="block px-4 py-2 hover:bg-gray-50 text-[20px] hover:text-[#62b6a6]"
                        >
                          Events
                        </Link>
                      </div>
                  )}
                </div>
              </nav>

              {/* Right buttons */}
              <div className="flex items-center gap-6">
                <Link
                    to="/account"
                    className="font-semibold text-[20px] text-gray-900 hover:text-[#62b6a6]"
                >
                  My Account
                </Link>

                {/*<Button variant="black" size="md" className="px-6 bg-black text-white">*/}
                {/*  Contact*/}
                {/*</Button>*/}

                <button
                    className="whitespace-nowrap text-[20px] cursor-pointer font-medium transition-all duration-200 bg-black hover:bg-teal-600 text-white rounded-full px-6 py-3">Contact
                </button>
              </div>
            </div>

            {/* Mobile burger */}
            <button
                className="lg:hidden w-8 h-8 flex items-center justify-center"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`} />
            </button>
          </div>

          {/* Mobile menu */}
          {isMenuOpen && (
              <div className="lg:hidden fixed inset-0 bg-white z-50 p-6">
                <div className="flex flex-col gap-6">
                  <Link to="/membership" onClick={() => setIsMenuOpen(false)}>
                    Memberships
                  </Link>
                  <Link to="/classes" onClick={() => setIsMenuOpen(false)}>
                    Classes
                  </Link>
                  <Link to="/infrared-hot-yoga" onClick={() => setIsMenuOpen(false)}>
                    Infrared Hot Yoga
                  </Link>
                  <Link to="/schedule" onClick={() => setIsMenuOpen(false)}>
                    Schedule
                  </Link>
                  <Link to="/about" onClick={() => setIsMenuOpen(false)}>
                    About
                  </Link>
                  <Link to="/events" onClick={() => setIsMenuOpen(false)}>
                    Events
                  </Link>

                  <hr />

                  <Link to="/account" className="font-semibold">
                    My Account
                  </Link>

                  <Button size="lg" className="rounded-full bg-black text-white">
                    Contact
                  </Button>
                </div>
              </div>
          )}
        </div>
      </header>
  );
}
